import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import RouteErrorBoundary from './components/RouteErrorBoundary';

// Add global error logging to see what's failing
window.addEventListener('error', (e) => {
	console.error('Global error:', e.error || e.message, e.filename, e.lineno);
});

window.addEventListener('unhandledrejection', (e) => {
	console.error('Unhandled promise rejection:', e.reason);
});

const AppWithProviders = () => (
	<React.StrictMode>
		<HelmetProvider>
			<App />
		</HelmetProvider>
	</React.StrictMode>
);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

const root = createRoot(rootEl);
root.render(
	<BrowserRouter>
		<RouteErrorBoundary>
			<React.Suspense fallback={<div>Loading...</div>}>
				<AppWithProviders />
			</React.Suspense>
		</RouteErrorBoundary>
	</BrowserRouter>
);
